<template>
  <router-view/>
</template>

<script>

if(window.location.origin == "http://localhost:8080") {
  window.api_url = "https://stp62.ru/api/v1/";
  window.server_url = "https://stp62.ru/";
}
else {
  window.api_url = window.location.origin + "/api/v1/";
  window.server_url = window.location.origin + "/";
}

</script>

<style>

:root {
  --Border: #EDEDED;
  --White: #FFF;
  --BG: #F8F8F8;
  --Black: #222;
  --Blue: #1B78BC;
  --Gray: #656565;
  --Red: #FA4B61;
  --Green: #69BE15;
}

body {
  margin: 0;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

body::-webkit-scrollbar {
  width: 3px; /* Ширина всего элемента навигации */
}

body::-webkit-scrollbar-track {
  background: #fff; /* Цвет дорожки */
}

body::-webkit-scrollbar-thumb {
  background: var(--Gray, #656565); /* Цвет бегунка */
  border-radius: 20px; /* Округление бегунка */
  border: 3px solid var(--Border, #EDEDED); /* Оформление границ бегунка */
}

main::-webkit-scrollbar {
  width: 3px; /* Ширина всего элемента навигации */
}

main::-webkit-scrollbar-track {
  background: #fff; /* Цвет дорожки */
}

main::-webkit-scrollbar-thumb {
  background: var(--Gray, #656565); /* Цвет бегунка */
  border-radius: 20px; /* Округление бегунка */
  border: 3px solid var(--Border, #EDEDED); /* Оформление границ бегунка */
}
</style>
